(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sv-mobile-home"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = () => document.querySelectorAll('[data-mobile-home]').forEach(home => {
    if (home.dataset.ready) return;
    const tabs = [...home.querySelectorAll('[data-mobile-tab]')];
    const panels = [...home.querySelectorAll('[data-mobile-panel]')];
    if (tabs.length !== 3 || panels.length !== 3) return;
    const nav = home.querySelector('.sv-m-tabs');
    const select = (key, focus = false) => {
      tabs.forEach(tab => {
        const active = tab.dataset.mobileTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus({preventScroll:true});
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.mobilePanel !== key; });
      home.dataset.selected = key;
    };
    nav.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].tabIndex = 0;
      tab.addEventListener('click', event => { event.preventDefault(); select(tab.dataset.mobileTab); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (event.key === ' ') { event.preventDefault(); select(tab.dataset.mobileTab); }
        if (next !== undefined) { event.preventDefault(); select(tabs[next].dataset.mobileTab, true); }
      });
    });
    select('cold');
    home.dataset.ready = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true}); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-refonte-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sv-refonte-navigation')) {
    customElements.define('sv-refonte-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.setAttribute('data-enhanced', '');
        this.disclosures = Array.from(this.querySelectorAll('details'));
        this.disclosures.forEach(details => {
          const summary = details.querySelector(':scope > summary');
          const sync = () => summary?.setAttribute('aria-expanded', String(details.open));
          sync();
          details.addEventListener('toggle', () => {
            sync();
            if (details.open && details.classList.contains('sv-rn__disclosure')) {
              this.querySelectorAll('.sv-rn__disclosure[open]').forEach(other => {
                if (other !== details) other.open = false;
              });
            }
          }, { signal });
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const activeDetails = event.target.closest('details[open]');
          if (!activeDetails || !this.contains(activeDetails)) return;
          event.preventDefault();
          event.stopPropagation();
          activeDetails.open = false;
          activeDetails.querySelector(':scope > summary')?.focus();
        }, { signal });
        this.addEventListener('click', event => {
          if (event.target.closest('[data-sv-rn-close]')) this.close(true);
          else if (event.target.closest('a')) this.close(false);
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.close(false);
        }, { signal });
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
        }, { signal });
        const viewport = window.matchMedia('(min-width:990px)');
        viewport.addEventListener('change', () => this.close(false), { signal });
      }
      close(restoreFocus = false) {
        const first = this.querySelector('details[open] > summary');
        this.disclosures?.forEach(details => { details.open = false; });
        if (restoreFocus) first?.focus();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
